
import {
  AnalysisResultsForCheckup,
  CheckupRequestAnalysisStatus,
  GaitMlResults
} from '@companion-professional/dctypes';

// getAnalysisStatusForGait is a function that takes in the analysis results for a checkup and returns the analysis
// status for the gait analysis.  This is used on the dashboard to show the status of the gait analysis for each
// checkup.
export const getAnalysisStatusForGait = (
    anaysisResults: Record<string, AnalysisResultsForCheckup>,
    checkupId: string,
  
    // alertStatuses are the alert statuses that we want to check for, if any of these statuses are present (and the
    // analysis has been completed), we will return the 'gait_anomaly' CheckupRequestAnalysisStatus.  Otherwise, we will
    // return 'no_anomaly_detected'.
    alertStatuses: string[] = ['high', 'medium']
  ): CheckupRequestAnalysisStatus => {
    // If there isn't an entry for the checkup in the analysis results, then we return not_started
    if (!anaysisResults[checkupId] || !anaysisResults[checkupId].items) {
      return 'not_started';
    }
  
    // Check all the analyses for the checkup's items for gait results
    const gaitResults: { results: GaitMlResults; status: string }[] = Object.values(anaysisResults[checkupId].items)
      .filter((value) => {
        return value.results && value.results.gait;
      })
      .map((value) => ({ results: value.results.gait as GaitMlResults, status: value.status }));
  
    if (gaitResults.length === 0) {
      return 'not_started';
    }
  
    // If any of the analyses are still processing, then we return processing
    if (gaitResults.some((gaitObject) => gaitObject.status === 'processing')) {
      return 'processing';
    }
  
    // If the analysis is complete, then we will check if the alert status is present
    if (gaitResults.every((gaitObject) => gaitObject.status === 'completed')) {
      const hasAlertStatus = gaitResults.some((gaitObject) => alertStatuses.includes(gaitObject.results.confidence));
      return hasAlertStatus ? 'gait_anomaly' : 'no_anomaly_detected';
    }
  
    return 'not_started';
  
};